<template>
  <div class="HTLink">
    <div @click="ToHT(link.src)" v-for="(link, index) in linkList" :key="index">
      <img :src="link.image" alt="" />
      <span>{{ link.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      linkList: this.cityDetail.backstageUrlList,
    }
  },
  methods: {
    ToHT (href) {
      if (href) {

        window.open(href)
      }
      // window.open('http://117.159.53.44:10006')
    },
  },
}
</script>

<style scoped>
.HTLink {
  height: 200px;
  margin: 10px 0;
  display: flex;
  align-items: center;
  background: url("../../../assets/img/ljbj.png") no-repeat;
  background-size: 100% 100%;
  justify-content: space-around;
}
.HTLink > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.HTLink > div > img {
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
}
.HTLink > div > span {
  font-size: 20px;
  font-weight: bold;
}
</style>
